import { v4 as uuidv4 } from 'uuid';

export function MinicartProductListContentMobile(props = {}, childrenComponents = []) {
	return {
		componentName: 'MinicartProductListContentMobile',
		componentId: uuidv4(),
		props,
		childrenComponents,
	};
}
